module.exports = __webpack_public_path__ + "img/lamp-fill.a46b292a.svg";